module.exports = require("constants");